var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGoogleClassroom = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 39.727,
    viewBox: "0 0 46 39.727",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #0f9d58;\n      }\n\n      .cls-2 {\n        fill: #57bb8a;\n      }\n\n      .cls-3 {\n        fill: #f7f7f7;\n      }\n\n      .cls-4 {\n        fill: #f1f1f1;\n      }\n\n      .cls-5 {\n        fill: #f4b400;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-6, .cls-7, .cls-9 {\n        opacity: 0.2;\n      }\n\n      .cls-7 {\n        fill: #bf360c;\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-9 {\n        fill: #263238;\n      }\n\n      .cls-10 {\n        fill: url(#radial-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.014,
    x2: 0.5,
    y2: 1.01,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#bf360c",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf360c",
    stopOpacity: 0.02
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.034,
    cy: 0.023,
    r: 4.777,
    gradientTransform: "translate(0.005) scale(0.864 1)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "google-classroom",
    transform: "translate(0 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4343",
    "data-name": "Path 4343",
    className: "cls-1",
    d: "M48,84H85.636v31.364H48Z",
    transform: "translate(-43.818 -43.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4344",
    "data-name": "Path 4344",
    className: "cls-2",
    d: "M129.955,226.7a2.352,2.352,0,1,0-2.352-2.352A2.354,2.354,0,0,0,129.955,226.7Zm0,1.568c-2.518,0-5.227,1.333-5.227,2.988v1.716h10.455v-1.716C135.182,229.606,132.472,228.273,129.955,228.273ZM113.227,226.7a2.352,2.352,0,1,0-2.352-2.352A2.354,2.354,0,0,0,113.227,226.7Zm0,1.568c-2.518,0-5.227,1.333-5.227,2.988v1.716h10.455v-1.716C118.455,229.606,115.745,228.273,113.227,228.273Z",
    transform: "translate(-98.591 -169.795)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4345",
    "data-name": "Path 4345",
    className: "cls-3",
    d: "M187.318,186.273a3.136,3.136,0,1,0-3.136-3.136A3.134,3.134,0,0,0,187.318,186.273Zm0,2.091c-3.528,0-7.318,1.873-7.318,4.182v2.091h14.636v-2.091C194.636,190.237,190.847,188.364,187.318,188.364Z",
    transform: "translate(-164.318 -131.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4346",
    "data-name": "Path 4346",
    className: "cls-4",
    d: "M312,420h9.409v2.091H312Z",
    transform: "translate(-284.818 -350.545)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4347",
    "data-name": "Path 4347",
    className: "cls-5",
    d: "M42.864,36H3.136A3.134,3.134,0,0,0,0,39.136V72.591a3.134,3.134,0,0,0,3.136,3.136H42.864A3.134,3.134,0,0,0,46,72.591V39.136A3.134,3.134,0,0,0,42.864,36ZM41.818,71.545H4.182V40.182H41.818Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4348",
    "data-name": "Path 4348",
    className: "cls-6",
    d: "M42.864,36H3.136A3.134,3.134,0,0,0,0,39.136V39.4a3.134,3.134,0,0,1,3.136-3.136H42.864A3.134,3.134,0,0,1,46,39.4v-.261A3.134,3.134,0,0,0,42.864,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4349",
    "data-name": "Path 4349",
    className: "cls-7",
    d: "M42.864,456.136H3.136A3.134,3.134,0,0,1,0,453v.261A3.134,3.134,0,0,0,3.136,456.4H42.864A3.134,3.134,0,0,0,46,453.261V453A3.134,3.134,0,0,1,42.864,456.136Z",
    transform: "translate(0 -380.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4350",
    "data-name": "Path 4350",
    className: "cls-8",
    d: "M321.209,444H311.8l4.182,4.182h9.4Z",
    transform: "translate(-284.636 -372.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4351",
    "data-name": "Path 4351",
    className: "cls-9",
    d: "M48,81H85.636v.261H48Z",
    transform: "translate(-43.818 -41.08)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4352",
    "data-name": "Path 4352",
    className: "cls-6",
    d: "M48,444H85.636v.261H48Z",
    transform: "translate(-43.818 -372.455)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4353",
    "data-name": "Path 4353",
    className: "cls-10",
    d: "M42.864,36H3.136A3.134,3.134,0,0,0,0,39.136V72.591a3.134,3.134,0,0,0,3.136,3.136H42.864A3.134,3.134,0,0,0,46,72.591V39.136A3.134,3.134,0,0,0,42.864,36Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleClassroom);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-classroom.59778f9b3f8df7e4b7de1b07ea317c61.svg";